import * as actions from "libs/actions";
import { withActionContext, write } from "./write";
import { AlertDialogState } from "~/dialogs/alert/AlertDialog";
import { ParsedToken } from "libs/searchQueryParser";
import { InvalidActionStateError } from "libs/actions";

/* -------------------------------------------------------------------------------------------------
 *  updateInboxSection
 * -------------------------------------------------------------------------------------------------
 */

export type UpdateInboxSectionProps = {
  inboxSectionId: string;
  subsections: Array<{
    id: string;
    name: string;
    query: ParsedToken[];
  }>;
};

export const updateInboxSection = withActionContext(async (context, environment, props: UpdateInboxSectionProps) => {
  if (!environment.network.isOnline()) {
    AlertDialogState.open({
      content: "You must be online to edit your inbox sections",
    });

    // Intentionally using an AlertDialogState (for slightly better UX)
    throw new InvalidActionStateError("[updateInboxSection] Client is offline", { userMessage: "SUPPRESS" });
  }

  const ownerOrganizationId = environment.auth.getAndAssertCurrentUserOwnerOrganizationId();

  return {
    forward: async () => {
      const action = await actions.inboxSection.updateInboxSection.action(
        {
          ...props,
          ownerOrganizationId,
        },
        context,
      );

      await write(environment, { action });

      await environment.api.reindexInboxSections({
        notificationDeliveredAt: {
          onOrBefore: new Date().toISOString(),
        },
      });
    },
  };
});
